import { tss } from '@/shared/styles/tss'

export const useStyles = tss.withName('Leaders').create(({ theme }) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    alignSelf: 'center',
    justifyContent: 'stretch',

    width: '100%',
    height: '100vh',
    padding: '0px 12px',
    marginBottom: '5vh',
    overflow: 'auto',
    overflowX: 'hidden',
    WebkitOverflowScrolling: 'touch',
    overscrollBehaviorY: 'none',
  },

  imageContainer: {
    position: 'relative',
  },

  tvgaAndTabsWrapper: {
    display: 'flex',
    width: '100%',
    flexDirection: 'column',
    margin: '12px',
    gap: '12px',
  },

  title: {
    textAlign: 'center',
    fontFamily: 'Inter',
    fontWeight: '400',
    fontSize: theme.sizes.texts.fontSize.l,

    fontStyle: 'normal',
    lineHeight: '40px',
    color: theme.colors.text.primary,
  },
  tabList: {
    backgroundColor: '#2e2f34',
    position: 'sticky',
    opacity: '1',
    minHeight: '32px',
  },
  coinIcon: {
    height: '12px',
    width: '12px',
  },
  coinIcon2: {
    height: '16px',
    width: '16px',
  },

  stickyHeaderWrapper: {
    position: 'sticky',
    top: 36,
    zIndex: 12,
    background: theme.colors.background.primary,
    width: '100%',
  },

  header: {
    top: '40px',
    zIndex: '5',
    alignItems: 'center',
    height: 'auto',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'stretch',
    width: '100%',
    padding: '12px 32px',
    color: theme.colors.text.secondary,
    background: theme.colors.background.primary,
    div: {
      display: 'flex',
      flexDirection: 'row',
    },
  },

  placeTittle: {
    alignItems: 'start',
    justifyContent: 'start',
    textAlign: 'start',
    width: '40%',

    fontSize: theme.sizes.texts.fontSize.xs,
    lineHeight: theme.sizes.texts.lineHeight.xs,

    fontWeight: 370,
  },

  nameTittle: {
    alignItems: 'start',
    justifyContent: 'start',
    textAlign: 'start',
    textTransform: 'uppercase',
    width: '100%',

    fontSize: theme.sizes.texts.fontSize.xs,
    lineHeight: theme.sizes.texts.lineHeight.xs,

    fontWeight: 370,
  },

  variant: {
    alignItems: 'start',
    justifyContent: 'end',
    textAlign: 'end',
    textTransform: 'uppercase',
    width: '100%',

    fontSize: theme.sizes.texts.fontSize.xs,
    lineHeight: theme.sizes.texts.lineHeight.xs,

    fontWeight: 370,
  },

  bgImage: {
    width: '100vw',
    height: '55vw',
    backgroundImage: 'url(/assets/backgrounds/LeaderboardBG.webp)',
    backgroundPosition: 'center',
    backgroundSize: 'cover',
  },

  tabListWrapper: {
    background: theme.colors.background.primary,
    display: 'flex',
    justifyContent: 'center',
    position: 'sticky',
    top: '0',
    marginTop: '36px',
    paddingTop: '8px',
    zIndex: '10',
    minHeight: '50px',
  },

  totalAccountValueWrapper: {
    position: 'absolute',
    display: 'flex',
    width: '100%',
    gap: '4px',
    paddingTop: '24px',
    alignSelf: 'center',
    flexDirection: 'column',
    alignItems: 'center',
    textAlign: 'center',
    textTransform: 'uppercase',
    color: theme.colors.text.primary,
  },

  totalAccountValueText: {
    fontSize: '12px',
    fontWeight: 330,
    lineHeight: '14px',
  },

  totalAccountValue: {
    fontFamily: 'Inter',
    fontWeight: 600,
    fontSize: '38px',
  },

  topUserseRoot: {
    width: '100%',
    display: 'flex',
    alignItems: 'flex-end',
    position: 'relative',
  },

  userContainerWrapper: {
    width: '33%',
    display: 'flex',
    flexDirection: 'column',
    gap: '4px',
    position: 'relative',
  },

  userContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: '4px',
    justifyContent: 'center',
    width: '100%',
  },

  gigiWrapper: {
    position: 'absolute',
    alignSelf: 'center',
    top: '104px',
    display: 'flex',
    zIndex: '5',
    gap: '4px',
    alignItems: 'center',

    span: {
      fontWeight: 440,
      fontSize: '14px',
      color: 'white',
    },
  },

  avatarWrapper: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '2px',
  },

  nameWrapper: {
    display: 'flex',
    gap: '2px',
    justifyContent: 'center',
    width: '100%',

    span: {
      fontSize: '14px',
      fontWeight: 350,
      textAlign: 'center',
      color: 'white',

      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      display: 'inline-block',
      maxWidth: '100%',
    },
  },

  //   emoji: {
  //     display: 'flex',
  //     alignItems: 'center',
  //     justifyContent: 'center',
  //     height: '40px',
  //     width: '40px',

  //     img: {
  //       width: '100%',
  //       height: '100%',
  //     },
  //   },
}))
